// ##### Komarov 2025-10-06
import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * RobotsMeta component that adds noindex meta tag for search results pages
 * Works on both client and server side
 * @param {Object} props - Component props
 * @param {Object} [props.req] - Request object (server-side only)
 */
const RobotsMeta = ({ req }) => {
  const shouldAddNoIndex = () => {
    // Server-side check
    if (req && req.originalUrl) {
      console.log('req.originalUrl', req.originalUrl);
      return req.originalUrl.includes('search_results_hotels');
    }

    // Client-side check
    if (typeof window !== 'undefined') {
      return window.location.pathname.includes('search_results_hotels');
    }

    return false;
  };

  if (!shouldAddNoIndex()) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};

export default RobotsMeta;
